import { CSSProperties } from 'react';

export function modalBoxStyle(isMobile: boolean, large?: boolean): CSSProperties {
	return {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: isMobile ? '90vw' : large ? '75vw' : 500,
		maxHeight: '90vh',
		backgroundColor: 'background.paper',
		borderRadius: '0.4rem',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		overflowY: 'auto',
		padding: 2,
	};
}

export function modalTitleStyle(): CSSProperties {
	return {
		fontFamily: 'Poppins',
		fontWeight: '800',
		fontSize: '1.2rem',
		color: '#0086fb',
		width: '100%',
		textAlign: 'center'
	};
}

export function modalSubtitleStyle(): CSSProperties {
	return {
		fontFamily: 'Poppins',
		fontSize: '1rem',
		color: '#000000',
		width: '100%',
		textAlign: 'center'
	};
}

export function modalCloseStyle(): CSSProperties {
	return {
		width: '2.5rem',
		height: '2.5rem',
		position: 'absolute',
		top: '0',
		right: '0'
	};
}
